var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockIcon = function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#515151",
    fillRule: "evenodd",
    d: "M8.75 4.333h-.625V3.095C8.125 1.385 6.725 0 5 0S1.875 1.386 1.875 3.095v1.238H1.25C.562 4.333 0 4.89 0 5.57v5.192C0 11.442.563 12 1.25 12h7.5c.688 0 1.25-.557 1.25-1.238v-5.19c0-.682-.563-1.24-1.25-1.24zm-1.813 0H3.063V3.095c0-1.06.87-1.92 1.938-1.92 1.07 0 1.938.86 1.938 1.92v1.238zM4 7c0-.553.444-1 1-1 .552 0 1 .44 1 1v1.158c0 .552-.444 1-1 1-.552 0-1-.44-1-1v-1.16z"
  })));
};
export default SvgLockIcon;